export const types = {
  login: "[Auth] Login",
  logout: "[Auth] Logout",

  uiSetError: '[UI] Set Error',
  uiRemoveError : '[UI] Remove Error'
};
